import { commonPlaceholder } from 'modules/overlay-canvas/types/placeholders/create-argument';

interface IItem extends commonPlaceholder {
  listName: string;
}

export const complexPlaceholdersList: IItem[] = [
  {
    listName: 'Последние результаты команды',
    indicator: 'lastGameResults',
    blockText: 'Последние результаты\nкоманды',
    type: 'image',
    teamIndex: 0,
  },
  {
    blockText: 'Состав команды',
    indicator: 'teamComposition',
    listName: 'Состав команды',
    type: 'composition',
    teamIndex: 0,
  },
  {
    blockText: 'Фолы команды в тайме',
    indicator: 'teamPeriodFouls',
    listName: 'Фолы команды в тайме',
    type: 'composition',
    teamIndex: 0,
  },
];
